import { useNavigation } from '@react-navigation/core'
import React, { useCallback } from 'react'
import { Linking } from 'react-native'
import { Text } from 'react-native-paper'
import { useThemeStyle } from '@linqpal/common-frontend/src/hooks'
import { helpers } from '@linqpal/common-frontend'

const { composeStyle } = helpers

const makeStyles = theme => ({
  linkLabel: {
    color: theme.colors.accentText,
    fontSize: 16,
    fontWeight: '500',
    lineHeight: 24
  }
})

export default function LinkLabel (props) {
  const {
    children,
    url,
    screen,
    params,
    onPress,
    style
  } = props
  const navigation = useNavigation()
  const _onPress = useCallback(() => {
    screen && navigation.navigate(screen, params)
    url && Linking.canOpenURL(url).then(() => Linking.openURL(url))
  }, [screen, url, navigation])
  const styles = useThemeStyle(makeStyles)
  return (
    <Text onPress={onPress || _onPress} style={composeStyle(styles.linkLabel, style)}>
      {children}
    </Text>
  )
}
